import Crud from '../components/Configurations/Crud'
import Entity from '../components/Configurations/Add'

let routes = {
    path: '/configurations',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/configurations/add',
            name: 'Nova Configuração',
            component: Entity
        },
        {
            path: '/configurations/edit/:id?',
            name: 'Editar Serviço Adicional',
            component: Entity
        },
        {
            path: '/configurations',
            name: 'Configurações',
            component: Crud
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/configuration.js